<template>
  <section class="content">
    <DataTable :value="roleLists" :paginator="true" :rows="8" :filters="filters"
    class="p-datatable-responsive p-datatable-gridlines" data-key="id">
      <Column header="S.N">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" field="name" filterMatchMode="contains" :sortable="true" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
        <Column header="Action" >
       <template #body="slotProps">
        <Button class="p-button-raised p-button-success" @click="editRole(slotProps.data)"
         icon="pi pi-pencil"/>
        <Button class="p-button-raised p-button-danger" v-if="!slotProps.data.systemOnly"
             @click="openDialog(slotProps.data.id)"  icon="pi pi-trash"/>
        <Button class="p-button-raised p-button-danger"
            v-else @click="openDialog(slotProps.data.id)" disabled icon="pi pi-trash"/>
      </template>
      </Column>
    </DataTable>
    <Dialog v-model="dialogShow" @deleted="deleteRole"/>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'roleList',
  data () {
    return {
      message: '',
      dialogShow: false,
      roleId: '',
      filters: {}
    }
  },
  computed: {
    roleLists() {
      return this.$store.state.users.roleLists
    }
  },
  mounted() {
    this.roleList()
  },
  methods: {
    async roleList() {
      await this.$store.dispatch('loadRole')
    },
    async deleteRole(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        roleId: this.roleId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteRole', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
        this.dialogShow = !this.dialogShow
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'error'
        }
        this.$emit('delete-message', message)
      }
    },
    cancel() {
      this.show = false
      this.dialogShow = false
      this.deleteReason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.roleId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    editRole(data) {
      this.$emit('edit-role', data)
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  }
}
</script>
<style>
.p-datatable table {
    border-collapse: collapse;
    width: 100%;
    table-layout: auto;
    column-gap: inherit;
}
</style>



// WEBPACK FOOTER //
// roleList.vue?3856d6cb